import React, { useState, useCallback } from "react";
import './styles.css';
import ForgotPasswordAPI from "../api/forgotPass";
import { useNavigate } from "react-router-dom";
import Alert from "../components/alert";

const ForgotPassword = () => {
    const [username, setUsername] = useState<string>('');
    const [errorCode, setErrorCode] = useState<number | null>(null);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const nav = useNavigate();

    const setError = useCallback((code: number, message: string) => {
        setErrorCode(code);
        setErrorMessage(message);
    }, []);

    const handleGetUser = async () => {
        let res;
        try {
           res = await ForgotPasswordAPI(username);
           if (res.success)
                setError(0, res.message)
            else
                setError(1, res.message);
        } catch {
            setError(1, res.message);
        }
    }

    const handleGoHome = () => {
        nav('/');
    }

    const handleClose = () => {
        setErrorCode(null);
        setErrorMessage('');
    }

    return (
        <div className="main flex flex-col max-h-max">
            <div className="flex-1 flex justify-center items-center pt-10">
                <div className="bgShadow flex flex-col justify-center p-10 w-[40%] max-w-md items-center">
                    <h1 className="mb-4 text-md sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl font-medium leading-none tracking-tight text-gray-900 dark:text-white text-center">Locked out of your account?</h1>
                    <p className="sampleLabel text-center text-md max-w-md">Please enter your registered email or username below, and we'll send you a link to reset your password and get you back in the driver's seat.</p>
                    <div className="mt-4 mb-4">
                        <input type="text" className="textInput max-w-md" placeholder="Username / Email" value={username} onChange={(e) => { setUsername(e.target.value) }} />
                    </div>
                    <div className="flex justify-between items-center gap-2">
                        <button className="button-11" onClick={handleGetUser}>Submit</button>
                        <button className="button-11" onClick={handleGoHome}>Cancel</button>
                    </div>
                </div>
                {errorCode !== null ? (
                    <div className="absolute top-0 right-0">
                        <Alert 
                            code={errorCode} 
                            message={errorMessage} 
                            onClose={handleClose} 
                        />
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default ForgotPassword